import React, { useEffect, useState } from 'react';
import DataGridTable from '../components/DataGridTable';
import columns from '../components/columns/OrderColumns';
import useAppStore from "../appStore";
import axios from "axios";

const Orders = () => {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [recordColumns, setRecordColumns] = useState(columns);
    const baseURL = process.env.REACT_APP_API_URL;
    const { token } = useAppStore();

    useEffect(() => {
        setRecordColumns(columns);
        setLoading(false);
    }, []);


    useEffect(() => {
        getUsers();
    }, []);

    const getUsers = async () => {
        let posturl = baseURL + "/seller-order";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                setRecords(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className='p-4 mx-4'>
            <h1 className='mt-5 text-2xl text-blue-600'>All Orders</h1>
            <div className='mt-10'>
                {!loading && (
                    <DataGridTable data={records} columns={recordColumns} />
                )}
            </div>
        </div>
    );
};

export default Orders;
